import { easySettings } from "../src/shared/store/easyGlobalSettings";

window.EasySettings ||= {};

window.EasySettings = easySettings;
